import React from "react"
import { useRecoilValue } from "recoil"
import currentUser from "../../store/currentUser"
import { Link as RouterLink } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"
import EditIcon from "@material-ui/icons/Edit"

import Action from "../../components/Action"
import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"
import NameForm from "../../forms/Name"
import { formatPhone } from "../../libs/format"

const useStyles = makeStyles((theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  label: {
    fontWeight: "bold",
  },
  name: {
    fontSize: theme.spacing(3),
    fontWeight: "bold",
  },
}))

const Profile = () => {
  const classes = useStyles()
  const user = useRecoilValue(currentUser)
  const [edit, setEdit] = React.useState(false)

  return (
    <Layout title="Profile">
      <FormContainer>
        <Grid container alignItems="center" direction="column" spacing={3}>
          <Grid container>
            {edit ? (
              <Grid item>
                <NameForm setter={setEdit} />
              </Grid>
            ) : (
              <>
                <Grid item>
                  <Typography className={classes.name} component="h2">
                    {user.firstName} {user.lastName}
                  </Typography>
                </Grid>
                <Grid item>
                  <IconButton
                    onClick={(e) => {
                      e.preventDefault()
                      setEdit(true)
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Grid>
                <Grid item></Grid>
              </>
            )}
          </Grid>
          <Grid item>
            <Action component={RouterLink} to="/0/profile/password" variant="extended">
              <EditIcon className={classes.extendedIcon} /> Change Password
            </Action>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={2}>
          <Grid className={classes.label} item>
            Email
          </Grid>
          <Grid item>{user.email}</Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={2}>
          <Grid className={classes.label} item>
            Phone
          </Grid>
          <Grid item>{user.phone ? formatPhone(user.phone) : "—"}</Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={3}>
          <Grid item>
            <Action component={RouterLink} to="/0/profile/edit" variant="extended">
              <EditIcon className={classes.extendedIcon} /> Edit Contact
            </Action>
          </Grid>
        </Grid>
      </FormContainer>
    </Layout>
  )
}

export default Profile
